import React, { useEffect, useRef, useState } from 'react'
import Form from './Form';
import PageContainer from '../../forms/PageContainer/PageContainer';
import Success from './Success';

export default function MarketplaceSignup() {
    const [journey, setJourney] = useState(null);
    const [profileUrl, setProfileUrl] = useState(null)
    const formRef = useRef<HTMLDivElement>(null);
    const initialMount = useRef(true);

    useEffect(() => {
        if (initialMount.current) {
            initialMount.current = false;  // Set it to false after first render
            return;  // Exit from the effect to avoid scrolling on the first render
        }
        if (formRef.current) {
            formRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [journey]);

    return (
        <PageContainer ref={formRef}>
            {journey === null && <Form setJourney={setJourney} setProfileUrl={setProfileUrl} />}
            {journey === 'success' && <Success profileUrl={profileUrl} />}
        </PageContainer>
    );
}